"use strict";
var ButtonColor = /* @__PURE__ */ ((ButtonColor2) => {
  ButtonColor2["Primary"] = "ColorPrimary";
  ButtonColor2["Secondary"] = "ColorSecondary";
  ButtonColor2["Destruct"] = "ColorDestruct";
  return ButtonColor2;
})(ButtonColor || {});
var ButtonSize = /* @__PURE__ */ ((ButtonSize2) => {
  ButtonSize2["Large"] = "SizeLarge";
  ButtonSize2["Medium"] = "SizeMedium";
  ButtonSize2["Small"] = "SizeSmall";
  return ButtonSize2;
})(ButtonSize || {});
var ButtonVariant = /* @__PURE__ */ ((ButtonVariant2) => {
  ButtonVariant2["Filled"] = "VariantFilled";
  ButtonVariant2["Outlined"] = "VariantOutlined";
  ButtonVariant2["Text"] = "VariantText";
  return ButtonVariant2;
})(ButtonVariant || {});
class Button extends React.Component {
  render() {
    const classes = [
      "v3__button",
      `v3__button--color-${this.props.color || "ColorPrimary" /* Primary */}`,
      `v3__button--size-${this.props.size || "SizeLarge" /* Large */}`,
      `v3__button--variant-${this.props.variant || "VariantFilled" /* Filled */}`
    ];
    if (this.props.disabled) {
      classes.push("v3__button--disabled");
    }
    if (this.props.href) {
      return /* @__PURE__ */ React.createElement("a", { href: this.props.href, target: this.props.target, className: classes.join(" "), onClick: this.props.onClick, key: this.props.key, style: this.props.style }, /* @__PURE__ */ React.createElement("span", { className: "v3__button--label-wrapper" }, this.props.children));
    } else {
      return /* @__PURE__ */ React.createElement("button", { className: classes.join(" "), onClick: this.props.onClick, key: this.props.key, style: this.props.style }, /* @__PURE__ */ React.createElement("span", { className: "v3__button--label-wrapper" }, this.props.children));
    }
  }
}
;
export { Button, ButtonColor, ButtonSize, ButtonVariant };
